// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error__wrapper strong[data-v-44f5c9d7]{white-space:break-spaces}", "",{"version":3,"sources":["webpack://./resources/js/views/Profile.vue"],"names":[],"mappings":"AAEI,wCACI,wBADR","sourcesContent":["\n.error__wrapper {\n    strong {\n        white-space: break-spaces;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
